import { MutationConfig } from '@/utils/reactQuery'
import { getConfigOptions } from './getConfig'
import { MutationFunction, useMutation, useQueryClient } from '@tanstack/react-query'
import { OidcClientConfig } from '../types/authTypes'

type LoginRedirectProps = {
  config: OidcClientConfig
}

const loginRedirect = ({ config }: LoginRedirectProps) => {
  const authUrl = new URL(config.authorization_endpoint)
  const authParams = new URLSearchParams({
    response_type: 'code',
    client_id: import.meta.env.VITE_AUTH_CLIENT_ID,
    redirect_uri: import.meta.env.VITE_AUTH_LOGIN_REDIRECT_URI,
    scope: 'openid profile email',
  })
  authUrl.search = authParams.toString()
  window.location.href = authUrl.toString()
}

type UseLoginCallbackProps = {
  mutationConfig?: MutationConfig<MutationFunction<void, void>>
}

const useLoginRedirect = ({ mutationConfig }: UseLoginCallbackProps = {}) => {
  const { ...restConfig } = mutationConfig || {}
  const queryClient = useQueryClient()

  return useMutation({
    ...restConfig,
    mutationFn: async () => {
      const configQuery = getConfigOptions()
      const config = queryClient.getQueryData(configQuery.queryKey) ?? (await queryClient.fetchQuery(configQuery))
      loginRedirect({ config })
    },
  })
}

export { loginRedirect, useLoginRedirect }
